<template>
    <div class="user_order" v-loading="loading">
        <div class="order_titles">我的奖励</div>
        <div class="user_order_box1">
            <div class="box1_title">
                我的奖励
            </div>
            <div class="box1_nums">
                {{ money }}
            </div>
            <div class="box1_texts1">
                当前剩余可提现奖励
            </div>
            <div class="box1_btns">
                <div class="btns1" @click="handle_tx">奖励提现</div>
                <div class="btns2" @click="handle_family_list">我的家人</div>
                 <div class="btns2" @click="handle_share">我的分享大使</div>
            </div>
           
           
           
        </div>
        <div class="user_order_box2">
            <div class="box2_top">
                <div class="borders"></div>
                <div class="texts">邀请码管理</div>
            </div>
            <div class="box2_bom">
                <div class="bom1">
                    <div class="bom1_title">我的邀请码</div>
                    <div class="bom1_codes">{{ yqm }}</div>
                    <div class="bom1_btns" @click="handle_clipboard(yqm)">复制邀请</div>
                </div>
                <div class="bom1">
                    <div class="bom1_title">邀请链接</div>
                    <div class="bom1_codes">{{ yqm_url }}</div>
                    <div class="bom1_btns" @click="handle_clipboard(yqm_url)">复制链接</div>
                </div>
                <div class="bom2">
                    <div class="bom2_title">邀请二维码</div>
                    <div class="bom2_condes"></div>
                    <div class="bom2_btns">扫一扫</div>
                </div>
                <div class="bom2">
                    <div class="bom2_title">分享海报</div>
                    <div class="bom2_condes"></div>
                    <div class="bom2_btns">下载</div>
                </div>
            </div>
        </div>
        <div class="user_order_box3">
           <user_tab1 ref="user_tab1"></user_tab1>
        </div>

        <div class="user_order_box4">
            <user_tab2 ref="user_tab2"></user_tab2>
        </div>
    </div>
</template>
<script>
import { mapState} from 'vuex'
 
import user_tab1 from '@/components/user_jl/user_tab1.vue'
import user_tab2 from '@/components/user_jl/user_tab2.vue'
 

export default {
    components: {
        user_tab1,
        user_tab2
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword:'',//
            types_ac:1,
            money:'',
            yqm:'',
            yqm_url:'',
            type_list:[
                {
                    title:'待上传发票',
                    state:1,
                },
                {
                    title:'待审核',
                    state:2,
                },
                {
                    title:'未通过',
                    state:3,
                },
                {
                    title:'已发放',
                    state:4,
                },
                {
                    title:'已取消',
                    state:5,
                }
                
            ],
            order_list:[1],

            total:100,
            pages:{
                page:1,
                limit:10,
            },




            jl_list:[],
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_UserInfo()
    },
    methods: {
        handle_clipboard(text){
            navigator.clipboard.writeText(text).then(function() {
                alertSucc("复制成功！");
            }).catch(function(err) {
                alertErr("复制失败：" + err);
            });
        },
        handle_deitial(){
            this.$router.push({
                path:'/user_wt/user_wt_detial',
                query:{

                }
            })
        },
        handle_yq(){
            this.$refs.user_jf_pop.handle_open()
        },

        handle_family_list(){
            this.$router.push({
                path:'/user_jl/family_list',
                query:{

                },
            })
        },
        handle_share(){
            this.$router.push({
                path:'/user_jl/share',
                query:{

                },
            })
        },
        handle_tx(){
            this.$router.push({
                path:'/user_jl/payouts',
                query:{

                },
            })
        },
        get_UserInfo(){
            this.loading=true
            this.$api("getUserInfo", {
                
			}, "get").then((res) => {
                this.loading = false
                console.log('我的奖励',res)
                if (res.code == 1) {
                    this.money=res.data.money
                    this.yqm=res.data.yqm
                    let url=window.location.host
                    console.log('url',url)
                    this.yqm_url=url+'/enroll?code='+res.data.yqm
                } else {
                    alertErr(res.msg)
                }
            });
        },
      
    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box1{
        width: 1196px;
        height: 242px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 24px;
        padding: 24px 32px 32px 32px;
        .box1_title{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #B8C4D1;
            margin-bottom: 11px;
        }
        .box1_nums{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 52px;
            color: #333333;
            margin-bottom: 4px;
        }
        .box1_texts1{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;

        }
        .box1_btns{
            display: flex;
            align-items: baseline;
            padding-top: 25px;
            .btns1{
                width: 134px;
                height: 40px;
                background: #377CFD;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                cursor: pointer;
                text-align: center;
                line-height: 40px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;
                margin-right: 10px;

            }
            .btns2{
                width: 134px;
                height: 40px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #377CFD;
                text-align: center;
                line-height: 40px;
                cursor: pointer;
                cursor: pointer;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 14px;
                color: #377CFD;
                margin-right: 10px;

            }
        }
    }
    .user_order_box2{
        width: 1196px;
        height: 272px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 24px;
        .box2_top{
            display: flex;
            align-items: center;
            height: 56px;
            border-bottom: 1px solid #DEDEDE;
            .borders{
                width: 4px;
                height: 22px;
                background: #377CFD;
                border-radius: 3px 3px 3px 3px;
            }
            .texts{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 18px;
                color: #333333;
                padding-left: 28px;
            }
        }
        .box2_bom{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 27px 82px 30px 32px;
            .bom1{
                .bom1_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    text-align: left;
                }
                .bom1_codes{
                    margin-top: 43px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    text-align: left;

                }
                .bom1_btns{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;
                    cursor: pointer;
                    margin-top: 10px;
                    text-align: left;
                }
            }
            .bom2{
                .bom2_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    margin-bottom: 23px;
  
                }
                .bom2_condes{
                    width: 87px;
                    height: 87px;
                    background: #666666;
                    border-radius: 0px 0px 0px 0px;
                    margin-bottom: 11px;
                }
                .bom2_btns{
                    width: 87px;
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #377CFD;
                    text-align: center;
                }
            }
        }
    }
    .user_order_box3{
      
    }
    .user_order_box4{
        background-color: #FFFFFF;
        margin-top: 17px;
        .box3_top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 56px;
            border-bottom: 1px solid #DEDEDE;
            .top_left{
                display: flex;
                align-items: center;
                .borders{
                    width: 4px;
                    height: 22px;
                    background: #377CFD;
                    border-radius: 3px 3px 3px 3px;
                }
                .texts{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 18px;
                    color: #333333;
                    padding-left: 28px;
                }
            }
            .top_right{
                display: flex;
                align-items: center;
                padding-right: 58px;
                .type_item{
                    height: 56px;
                    margin-left: 50px;
                    cursor: pointer;
                    .type_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                        height: 53px;
                        // line-height: 53px;
                        padding-top: 23px;
                        padding-bottom: 9px;
                        text-align: center;

                    }
                    .type_bor{
                        width: 56px;
                        height: 3px;
                        border-radius: 0px 0px 0px 0px;
                        margin: auto;
                    }
                    &:hover{
                        .type_bor{
                            background: #377CFD;

                        }
                    }
                }
                .type_item_ac{
                    .type_bor{
                            background: #377CFD;

                        }
                }
            }
            
        }
        .box3_bom{
            padding:24px 32px;
            .order_list{
            padding-top: 23px;
            .order_tabs{
                width: 1132px;
                height: 44px;
                background: #F5F5F5;
                background-color: hsla(219, 98%, 60%, 0.03);
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                display: flex;
                align-items:center;
                justify-content: space-between;
                padding: 0 24px;
                .tables{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                }
                .tab1{
                    width: 280px;
                    flex-shrink: 0;
                }
                .tab2{
                    width: 210px;
                    flex-shrink: 0;
                }
                .tab3{
                    width: 280px;
                    flex-shrink: 0;
                }
                .tab4{
                    width: 160px;
                    flex-shrink: 0;
                }
                .tab5{
                    width: 160px;
                    flex-shrink: 0;
                }
            }
            .order_items{
                .items{
                    min-height: 64px;
                    border-left: 1px solid #E5E5E5;
                    border-right: 1px solid #E5E5E5;
                    border-bottom: 1px solid #E5E5E5;
                    padding: 20px 24px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .item1{
                        width: 280px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                    }
                    .item2{
                        width: 210px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                    }
                    .item3{
                        width: 280px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;

                    }
                    .item4{
                        width: 160px;
                        flex-shrink: 0;
                        display: flex;
                        .teges{
                            padding: 3px 12px;
                            border-radius: 2px 2px 2px 2px;
                            font-weight: 400;
                            font-size: 12px;

                        }
                        .tege_color1{
                            background: #F2F2F2;
                            color: #666666;
                            border: 1px solid #C1C1C1;
                        }
                        .tege_color2{
                            background: #E6F7FF;
                            color: #1890FF;
                            border: 1px solid #1890FF;

                        }


                    }
                    .item5{
                        width: 160px;
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        .btns1{
                            margin-right: 14px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                }
            }
            
        }
        }
    }
    .pages_box{
        width: 100%;
        height: 100px;
        // background-color: red;
        display: flex;
        align-items: center;
        justify-content: end;
        /deep/.el-pagination{
            .btn-prev{
                background-color: #FFFFFF;
                border: 1px solid #EEEEEE;  
                
            }
            .el-pager{
                .number {
                    background-color: #FFFFFF;
                    border: 1px solid #EEEEEE;  

                }
                .active{
                    background-color: #377CFD;
                }
                .el-icon{
                    background-color: #FFFFFF;
                }
            }
            .btn-next{
                background-color: #FFFFFF;
                border: 1px solid #EEEEEE;  

            }
        }
        .btns{
            width: 40px;
            height: 32px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #EEEEEE;  
            font-family: PingFang-SC-Medium, PingFang-SC-Medium;
            font-weight: normal;
            font-size: 14px;
            color: #7A7A7A;
            text-align: center;
            line-height: 32px;
            cursor: pointer;
        }
    }
}
</style>